import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard/narrativeCardFragment';
import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query NarrativesByCompanyCanonical($canonicalUrl: String!) {
    NarrativesByCompanyCanonical(companyCanonicalUrl: $canonicalUrl) {
      ...NarrativeCardFields
    }
  }
`,
  [NARRATIVE_CARD_FRAGMENT]
);

export const useCompanyNarratives = makeGqlQuery(QUERY);
